import { isAxiosError } from 'axios'

/** The server refused because too many requests came from this address (HTTP 429). */
export function isRateLimited(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 429
}
